module.exports = ".btn-logout {\n  position: absolute;\n  right: 1rem; }\n"